export default "__VITE_ASSET__aa7a8959__"